import { render, staticRenderFns } from "./window-item-tertiary.vue?vue&type=template&id=0a56eb79&scoped=true&"
import script from "./window-item-tertiary.vue?vue&type=script&lang=js&"
export * from "./window-item-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56eb79",
  null
  
)

export default component.exports